/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class UpdateClinicalPreferencesService {

    protected basePath = environment.appSetting.apiUrl+'patientportal';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.PatientPortalSendMessage
     * This API Sends message
     * @param messageboard Message box
     * @param practiceCode Set Practice value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public UpdateClinicalPreferences(PreferenceId: string,PatientId:number,SequenceIds:string,PatientPref:string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public UpdateClinicalPreferences(PreferenceId: string,PatientId:number,SequenceIds:string,PatientPref:string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public UpdateClinicalPreferences(PreferenceId: string,PatientId:number,SequenceIds:string,PatientPref:string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public UpdateClinicalPreferences(PreferenceId: string,PatientId:number,SequenceIds:string,PatientPref:string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;
        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header

        //const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        //if (httpContentTypeSelected != undefined) {
        //    headers = headers.set('Content-Type', httpContentTypeSelected);
        //}

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (PreferenceId !== undefined) {
            formParams = formParams.append('PreferenceId', <any>PreferenceId) || formParams;
        }
        if (PatientId !== undefined) {
            formParams = formParams.append('PatientId', <any>PatientId) || formParams;
        }
        if (SequenceIds !== undefined) {
            formParams = formParams.append('SequenceIds', <any>SequenceIds) || formParams;
        }
        if (PatientPref !== undefined) {
            formParams = formParams.append('PatientPref', <any>PatientPref) || formParams;
        }
        

        return this.httpClient.post<any>(`${this.basePath}/UpdateClinicalPreferences`,          
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
